<template>
  <div class="user_layout">
    <main class="layout_center">
      <router-view />
      <div class="back" @click="back">
        <a-icon type="left" />
        <span>返回登录</span>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'UserLayout2',
  data() {
    return {}
  },
  methods: {
    isReset(name) {
        return name === 'reset'
    },
    back() {
        this.$router.go(this.isReset(this.$route.name) ? -2 : -1)
    }
  }
}
</script>
<style lang="less" scoped>
.user_layout {
  height: 100%;
  background-color: #FFF;
  // border-top: 1px solid #ced3dc;
  .layout_center {
    width: 343px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    .back {
      font-size: 16px;
      color: #5e668d;
      padding-top: 24px;
      cursor: pointer;
    }
  }
}
</style>
